/**
 * @generated SignedSource<<767544d63dbb1eded1700fa7173a097c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PhotoStatus = "ACTIVE" | "DELETED" | "PENDING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerDetailsHeader_seller$data = {
  readonly dealerDetailsHeaderFeedback: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "OrderFeedbackPdp";
      } | null;
    } | null> | null;
  } | null;
  readonly isRewardsTier2: boolean | null;
  readonly liveStorefrontProfile: {
    readonly galleryAlbum: {
      readonly mediaList: ReadonlyArray<{
        readonly element: {
          readonly path?: string | null;
          readonly url?: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly headshots: ReadonlyArray<{
      readonly path: string | null;
      readonly status: PhotoStatus | null;
    } | null> | null;
  } | null;
  readonly monthsSinceStartDate: number | null;
  readonly sellerProfile: {
    readonly company: string | null;
  } | null;
  readonly sellerTiers: {
    readonly isGoldTier: boolean | null;
    readonly isPlatinumTier: boolean | null;
    readonly sellerTierDataNotFound: boolean | null;
  } | null;
  readonly shippingAddress: {
    readonly displayFullCityStateCountry: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerDetailsBioModalLazy_seller" | "PdpSharedDealerDetailsFeedback_seller" | "SharedStarRating_seller">;
  readonly " $fragmentType": "PdpSharedDealerDetailsHeader_seller";
};
export type PdpSharedDealerDetailsHeader_seller$key = {
  readonly " $data"?: PdpSharedDealerDetailsHeader_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerDetailsHeader_seller">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isExtended"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDealerDetailsHeader_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedStarRating_seller"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsFeedback_seller"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isExtended",
          "variableName": "isExtended"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsBioModalLazy_seller"
    },
    {
      "alias": "isRewardsTier2",
      "args": [
        {
          "kind": "Literal",
          "name": "listName",
          "value": "SELLER_REWARDS_2"
        }
      ],
      "kind": "ScalarField",
      "name": "isAnchorListMember",
      "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
    },
    {
      "alias": "monthsSinceStartDate",
      "args": [
        {
          "kind": "Literal",
          "name": "unit",
          "value": "MONTH"
        }
      ],
      "kind": "ScalarField",
      "name": "timeSinceStartDate",
      "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerProfile",
      "kind": "LinkedField",
      "name": "sellerProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "company",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "shippingAddress",
      "plural": false,
      "selections": [
        {
          "alias": "displayFullCityStateCountry",
          "args": [
            {
              "kind": "Literal",
              "name": "fullCountryName",
              "value": true
            }
          ],
          "kind": "ScalarField",
          "name": "displayCityStateCountry",
          "storageKey": "displayCityStateCountry(fullCountryName:true)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerTiers",
      "kind": "LinkedField",
      "name": "sellerTiers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGoldTier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPlatinumTier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sellerTierDataNotFound",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StorefrontProfile",
      "kind": "LinkedField",
      "name": "liveStorefrontProfile",
      "plural": false,
      "selections": [
        {
          "alias": "headshots",
          "args": [
            {
              "kind": "Literal",
              "name": "photoType",
              "value": "DEALER_STOREFRONT_HEADSHOT"
            }
          ],
          "concreteType": "Photo",
          "kind": "LinkedField",
          "name": "photos",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            (v0/*: any*/)
          ],
          "storageKey": "photos(photoType:\"DEALER_STOREFRONT_HEADSHOT\")"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MediaAlbum",
          "kind": "LinkedField",
          "name": "galleryAlbum",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MediaElement",
              "kind": "LinkedField",
              "name": "mediaList",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "element",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/)
                      ],
                      "type": "Photo",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "url",
                          "storageKey": null
                        }
                      ],
                      "type": "Video",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "dealerDetailsHeaderFeedback",
      "args": [
        {
          "kind": "Literal",
          "name": "feedbackSellerPublicNoteHasText",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 3
        },
        {
          "kind": "Literal",
          "name": "minimumReviewRating",
          "value": 4
        }
      ],
      "concreteType": "SellerOrderFeedbackPdpQueryConnection",
      "kind": "LinkedField",
      "name": "orderFeedbackPdp",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SellerOrderFeedbackPdpQueryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrderFeedbackPdp",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "orderFeedbackPdp(feedbackSellerPublicNoteHasText:true,first:3,minimumReviewRating:4)"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};
})();

(node as any).hash = "d8f9b78ae86339dd63db5b370c4b493a";

export default node;
